module.exports = __webpack_public_path__ + "static/media/background-squiggly.190703a9.svg";